module.exports = __webpack_public_path__ + "static/ccLogo-1be4b4b1ecb644161e25a1d3402a4e4a.png";